import React from 'react'
import {
    Form,
    // eslint-disable-next-line no-unused-vars
    Input,
    Select,
    Row,
    Col,
    Button,
    AutoComplete,
    // eslint-disable-next-line no-unused-vars
    InputNumber,
    Spin,
} from 'antd'
import debounce from 'lodash/debounce'
import API from '../../../services/API'

const { Option } = Select
// eslint-disable-next-line no-unused-vars
const AutoCompleteOption = AutoComplete.Option

class DiscountsConditionForm extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            autoCompleteResult: [],
            fetching: false,
        }
        // this.updateFields(props);
        this.fetchItems = debounce(this.fetchItems, 800)
    }

    componentDidMount() {
        this.updateFormProps();
    }

    updateFormProps() {
        const { setFieldsValue } = this.props.form
        // eslint-disable-next-line prefer-const
        let refreshForm = {}

        // if (this.props.apply_to) {
        //     refreshForm.apply_to = this.props.apply_to;
        // }
        // refreshForm.apply_to = 'products';
        if (this.props.item_based_condition) {
            if (this.props.item_based_condition.apply_to !== '') {
                refreshForm.apply_to = this.props.item_based_condition.apply_to;
            }
            if (this.props.item_based_condition.apply_when_buy !== '') {
                refreshForm.apply_when_buy = this.props.item_based_condition.apply_when_buy;
            }
            if (this.props.item_based_condition.items_to_apply !== '') {
                refreshForm.items_to_apply = this.props.item_based_condition.items_to_apply.map((g) => ({
                    key: g.id,
                    label: g.name,
                    ...g,
                }));
            }
            if (this.props.item_based_condition.buy_type !== '') {
                refreshForm.buy_type = this.props.item_based_condition.buy_type;
            }
            // if (this.props.item_based_each !== '') {
            //     refreshForm.item_based_each = this.props.item_based_each;
            // }
            if (this.props.item_based_condition.quantity_from) {
                refreshForm.quantity_from = this.props.item_based_condition.quantity_from;
            }
            if (this.props.item_based_condition.quantity_rule !== '') {
                refreshForm.quantity_rule = this.props.item_based_condition.quantity_rule;
            }
            // if (this.props.item_based_items_to_apply !== '') {
            //     refreshForm.item_based_items_to_apply = this.props.item_based_items_to_apply;
            // }
            if (this.props.item_based_condition.items_to_apply_count_option !== '') {
                refreshForm.items_to_apply_count_option = this.props.item_based_condition.items_to_apply_count_option;
            }
            if (this.props.item_based_condition.items_to_apply_count) {
                refreshForm.items_to_apply_count = this.props.item_based_condition.items_to_apply_count;
            }
            if (this.props.item_based_condition.items_to_buy) {
                refreshForm.items_to_buy = this.props.item_based_condition.items_to_buy.map((g) => ({
                    key: g.id,
                    label: g.name,
                    ...g,
                }));
            }
            if (this.props.item_based_condition.quantity_to) {
                refreshForm.quantity_to = this.props.item_based_condition.quantity_to;
            }
        } else {
            // eslint-disable-next-line no-lonely-if
            if (this.props.apply_to && typeof this.props.apply_to === 'object' && 'value' in this.props.apply_to) {
                refreshForm.apply_to = this.props.apply_to.value;
            } else if (this.props.apply_to && this.props.apply_to !== '') {
                refreshForm.apply_to = this.props.apply_to;
            }

            // eslint-disable-next-line no-lonely-if
            if (this.props.items_to_apply && this.props.items_to_apply.length > 0) {
                refreshForm.items_to_apply = this.props.items_to_apply;
                // refreshForm.items_to_apply = [1, 2, 3]
            }
        }
        // -------------------------------------------

        if (Object.keys(refreshForm).length !== 0) {
            // eslint-disable-next-line react/no-did-update-set-state
            setFieldsValue({ ...refreshForm }, () => {
                // this.setState({ loaded: true });
                // this.props.form.validateFields();
            });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                // aqui se debe ejecutar funcion de que se hizo todo bien
                // eslint-disable-next-line no-unused-expressions
                this.props.onCompleted && this.props.onCompleted()
            }
        })
    }

    getAppropiateItemUrl = (query) => {
        const currentSubsidiary = JSON.parse(localStorage.getItem('sucursal'))
        let subsidiaryFilter = '';
        if (currentSubsidiary) {
            subsidiaryFilter = `&filter[subsidiary_id]=${currentSubsidiary.id}`;
        }
        if (this.props.apply_to.value === 'specific_products' || this.props.apply_to.value === 'products') {
            return `/api/discounts/products-search?filter[q]=${query}`
        }

        if (this.props.apply_to.value === 'specific_brands' || this.props.apply_to.value === 'brands') {
            return `/api/discounts/brands-search?filter[name]=${query}`
        }
        if (this.props.apply_to.value === 'specific_product_types' || this.props.apply_to.value === 'product_types') {
            return `/api/discounts/product-types-search?filter[name]=${query}`
        }
        // eslint-disable-next-line quotes
        return `/api/categories${subsidiaryFilter}`
        // return `/api/categories?filter[name]=${query}`
    }

    getAppropiateItemUrlItemBased = (query) => {
        // esto e s a donde aplic a
        if (this.props.apply_when_buy.value === 'products') {
            return `/api/products?filter[q]=${query}`
        }

        if (this.props.apply_when_buy.value === 'brands') {
            return `/api/brands?filter[name]=${query}`
        }

        // eslint-disable-next-line quotes
        return `/api/categories?filter[name]=${query}`
        // return `/api/categories?filter[name]=${query}`
    }

    fetchItems = (value) => {
        if (value.length > 2) {
            this.setState({ autoCompleteResult: [], fetching: true })
            // eslint-disable-next-line prefer-const
            let uri = this.getAppropiateItemUrl(value)
            API.get(uri).then((response) => {
                this.setState({
                    fetching: false,
                    autoCompleteResult: response.data.data.map((item) => ({
                        text: item.name,
                        value: item.id,
                    })),
                })
            })
        }
    }

    fetchItemsWhenBuy = (value) => {
        if (value.length > 2) {
            this.setState({ autoCompleteResult: [], fetching: true })
            // eslint-disable-next-line prefer-const
            let uri = this.getAppropiateItemUrlItemBased(value)
            API.get(uri).then((response) => {
                this.setState({
                    fetching: false,
                    autoCompleteResult: response.data.data.map((item) => ({
                        text: item.name,
                        value: item.id,
                    })),
                })
            })
        }
    }

    add = () => {
        const { form } = this.props
        // can use data-binding to get
        const keys = form.getFieldValue('keys')
        // eslint-disable-next-line no-plusplus, no-undef
        const nextKeys = keys.concat(id++)
        // can use data-binding to set
        // important! notify form to detect changes
        form.setFieldsValue({
            keys: nextKeys,
        })
    }

    preventEnterSelection = (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault()
            e.stopPropagation()
        }
    }

    getSelectedValues = (fieldName) => {
        const value = this.props.form.getFieldValue(fieldName)
        if (!Array.isArray(value)) {
            return []
        }
        return value.map((item) => String(item && typeof item === 'object' ? item.key : item))
    }

    filterAlreadySelected = (fieldName) => {
        const selected = this.getSelectedValues(fieldName)
        return (d) => !selected.includes(String(d.value))
    }

    onItemsToApplyChange = (value) => {
        // const { form } = this.props
        if (typeof value === 'object' && value.value) {
            // eslint-disable-next-line no-param-reassign
            value = value.value;
        }
        this.setState({
            autoCompleteResult: [],
            fetching: false,
        })
        return value
    }

    renderItemBasedType = () => {
        // eslint-disable-next-line no-unused-vars
        const { getFieldDecorator, getFieldValue } = this.props.form
        const productOptions = [{key: 'any_product', label: 'Cualquier producto'}, {key: 'each_product', label: 'Cada producto'}, {key: 'combine_product', label: 'Combinado'}];
        const categorieOptions = [{key: 'any_category', label: 'Cualquier categoria'}, {key: 'each_category', label: 'Cada categoria'}, {key: 'combine_category', label: 'Combinado'}];
        const brandsOptions = [{key: 'any_brand', label: 'Cualquier marca'}, {key: 'each_brand', label: 'Cada marca'}, {key: 'combine_brand', label: 'Combinado'}];
        let widthQuantityTo = '0%';
        let requiredQuantityTo = false;
        let displayQuantityTo = 'none';
        let displayItemsToBuy = 'none';
        let requiredItemsToBuy = false;
        let widthQuantityFrom = '100%';
        let displayItemsToApplyCount = 'none';
        let requiredItemsToApplyCount = false;
        if (this.props.items_to_apply_count_option && this.props.items_to_apply_count_option.value && this.props.items_to_apply_count_option.value !== 'all') {
            displayItemsToApplyCount = 'inline';
            requiredItemsToApplyCount = true;
        }
        if (this.props.quantity_rule && this.props.quantity_rule.value && this.props.quantity_rule.value === 'from') {
            widthQuantityTo = '49%';
            requiredQuantityTo = true;
            widthQuantityFrom = '48%';
            displayQuantityTo = 'inline';
        }
        if (this.props.buy_type && this.props.buy_type.value && (
            this.props.buy_type.value !== 'any_product' && this.props.buy_type.value !== 'any_category' && this.props.buy_type.value !== 'any_brand'
        )) {
            displayItemsToBuy = 'inline'
            requiredItemsToBuy = true;
        }
        if (this.props.type.value === 'item_based') {
            return (
                <>
                    {this.renderApplyToCondition()}
                    <Form.Item label="Llevando: ">
                        {getFieldDecorator('buy_type', {
                            rules: [
                                {
                                    required: true,
                                    message: 'Selecciona al menos un tipo de venta',
                                },
                            ],
                            getValueFromEvent: (value) => {
                                this.props.form.setFieldsValue({
                                    items_to_buy: [],
                                });
                                return this.onItemsToApplyChange(value);
                            },
                        })(
                            <Select
                                placeholder="Selecciona tipo de compra"
                                style={{ width: '100%' }}
                                disabled={this.props.isLoading}
                            >
                                {this.props.apply_when_buy && this.props.apply_when_buy.value && this.props.apply_when_buy.value === 'products' && (productOptions.map((p) => <Option key={p.key}>{p.label}</Option>))}
                                {this.props.apply_when_buy && this.props.apply_when_buy.value && this.props.apply_when_buy.value === 'categories' && (categorieOptions.map((p) => <Option key={p.key}>{p.label}</Option>))}
                                {this.props.apply_when_buy && this.props.apply_when_buy.value && this.props.apply_when_buy.value === 'brands' && (brandsOptions.map((p) => <Option key={p.key}>{p.label}</Option>))}
                            </Select>,
                        )}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator('items_to_buy', {
                            rules: [
                                {
                                    required: requiredItemsToBuy,
                                    message: 'Selecciona al menos un elemento',
                                },
                            ],
                            getValueFromEvent: this.onItemsToApplyChange,
                        })(
                            <Select
                                mode="multiple"
                                disabled={this.props.isLoading}
                                labelInValue
                                placeholder="Busca elementos"
                                notFoundContent={this.state.fetching ? <Spin size="small" /> : null}
                                filterOption={false}
                                onSearch={this.fetchItemsWhenBuy}
                                style={{ width: '100%', display: displayItemsToBuy }}
                            >
                                {this.state.autoCompleteResult.filter(this.filterAlreadySelected('items_to_buy')).map((d) => (
                                    <Option key={d.value}>{d.text}</Option>
                                ))}
                            </Select>,
                        )}
                    </Form.Item>
                    <Form.Item label="Cantidad">
                        {getFieldDecorator('quantity_rule', {
                            rules: [
                                {
                                    required: true,
                                    message: 'Selecciona tipo de cantidad',
                                },
                            ],
                            getValueFromEvent: this.onItemsToApplyChange,
                        })(
                            <Select
                                placeholder="Selecciona tipo de cantidad"
                                style={{ width: '100%' }}
                                disabled={this.props.isLoading}
                            >
                                <Option value="more_than">Mayor igual que </Option>
                                <Option value="less_than">Menor igual que </Option>
                                <Option value="equals">Igual</Option>
                                <Option value="from">Desde</Option>
                            </Select>,
                        )}
                        {getFieldDecorator('quantity_from', {
                            rules: [
                                {
                                    required: true,
                                    message: 'Cantidad desde',
                                },
                            ],
                        })(
                            <Input
                                disabled={this.props.isLoading}
                                style={{ width: widthQuantityFrom }}
                                placeholder="Desde"
                                type="number"
                                step="1"
                            />,
                        )}
                        {getFieldDecorator('quantity_to', {
                            rules: [
                                {
                                    required: requiredQuantityTo,
                                    message: 'Cantidad a',
                                },
                            ],
                        })(
                            <Input
                                disabled={this.props.isLoading}
                                style={{ marginLeft: '1em', width: widthQuantityTo, display: displayQuantityTo }}
                                placeholder="A"
                                type="number"
                                step="1"
                            />,
                        )}
                    </Form.Item>
                    <Form.Item label="Toma descuento en:">
                        {getFieldDecorator('items_to_apply_count_option', {
                            rules: [
                                {
                                    required: true,
                                    message: 'Toma descuento en:',
                                },
                            ],
                            getValueFromEvent: this.onItemsToApplyChange,
                        })(
                            <Select
                                disabled={this.props.isLoading}
                                placeholder=""
                                style={{ width: '100%' }}
                            >
                                <Option value="all">En todas las cantidades</Option>
                                <Option value="apply_first">En las primeras n cantidades</Option>
                                <Option value="skip_first">Despues de las n cantidades</Option>
                            </Select>,
                        )}
                        {getFieldDecorator('items_to_apply_count', {
                            rules: [
                                {
                                    required: requiredItemsToApplyCount,
                                    message: 'N cantidad',
                                },
                            ],
                        })(
                            <Input
                                disabled={this.props.isLoading}
                                style={{
                                    display: displayItemsToApplyCount,
                                }}
                                placeholder="Cantidad"
                                type="number"
                                step="1"
                            />,
                        )}
                    </Form.Item>
                    <Form.Item label="Se aplica descuento en: ">
                        {getFieldDecorator('apply_to', {
                            rules: [
                                {
                                    required: true,
                                    message: 'Selecciona un caso',
                                },
                            ],
                            // getValueFromEvent: (value) => {
                            //     this.props.form.setFieldsValue({
                            //         items_to_apply: [],
                            //     });
                            //     return value;
                            // },
                        })(
                            <Select placeholder="Seleccione un caso" disabled={this.props.isLoading}>
                                <Option value="products">Productos</Option>
                                <Option value="brands">Marcas</Option>
                                <Option value="categories">Categorías</Option>
                            </Select>,
                        )}
                    </Form.Item>
                    <Form.Item label="Descuento en elementos: ">
                        {getFieldDecorator('items_to_apply', {
                            rules: [
                                {
                                    required: true,
                                    message: 'Selecciona al menos un elemento',
                                },
                            ],
                            getValueFromEvent: this.onItemsToApplyChange,
                        })(
                            <Select
                                disabled={this.props.isLoading}
                                mode="multiple"
                                labelInValue
                                placeholder="Busca elementos"
                                notFoundContent={this.state.fetching ? <Spin size="small" /> : null}
                                filterOption={false}
                                onSearch={this.fetchItems}
                                style={{ width: '100%' }}
                            >
                                {this.state.autoCompleteResult.filter((g) => g.value).filter(this.filterAlreadySelected('items_to_apply')).map((d) => (
                                    <Option key={d.value}>{d.text}</Option>
                                ))}
                            </Select>,
                        )}
                    </Form.Item>
                </>
            );
        }
        return null
    }

    renderApplyTo = () => {
        const { getFieldDecorator } = this.props.form
        return (
            <Form.Item label="Aplicar a">
                {getFieldDecorator('apply_to', {
                    rules: [
                        {
                            required: true,
                            message: 'Selecciona un caso',
                        },
                    ],
                    getValueFromEvent: (value) => {
                        this.props.form.setFieldsValue({
                            items_to_apply: [],
                        });
                        return this.onItemsToApplyChange(value);
                    },
                })(
                    <Select placeholder="Seleccione un caso" disabled={this.props.isLoading}>
                        <Option value="all_products">Todos los productos</Option>
                        <Option value="specific_products">Productos específicos</Option>
                        <Option value="specific_brands">Marcas específicas</Option>
                        <Option value="specific_product_types">Tipo de producto</Option>
                        {/* <Option value="specific_categories">Categorías específicas</Option> */}
                    </Select>,
                )}
            </Form.Item>
        );
    }

    renderApplyToCondition = () => {
        const { getFieldDecorator } = this.props.form
        return (
            <Form.Item label="En la compra de: ">
                {getFieldDecorator('apply_when_buy', {
                    rules: [
                        {
                            required: true,
                            message: 'Selecciona un caso',
                        },
                    ],
                    getValueFromEvent: (value) => {
                        this.props.form.setFieldsValue({
                            buy_type: '',
                            items_to_buy: [],
                        });
                        return value;
                    },
                })(
                    <Select placeholder="Seleccione un caso" disabled={this.props.isLoading}>
                        <Option value="products">Productos</Option>
                        <Option value="brands">Marcas</Option>
                        <Option value="categories">Categorías</Option>
                        {/* <Option value="product_types">Tipos de productos</Option> */}
                    </Select>,
                )}
            </Form.Item>
        );
    }

    // eslint-disable-next-line consistent-return
    renderItemsToApply = () => {
        const { getFieldDecorator } = this.props.form
        let tempItems = []
        if (this.props.items_to_apply && this.props.items_to_apply.length > 0) {
            tempItems = this.props.items_to_apply
        }
        if (this.props.items_to_apply.value && this.props.items_to_apply.value.length > 0) {
            tempItems = this.props.items_to_apply.value
        }
        if (this.props.apply_to.value && this.props.apply_to.value === 'specific_products') {
            return (
                <Form.Item label="Elige productos a aplicar">
                    <div onKeyDownCapture={this.preventEnterSelection}>
                        {getFieldDecorator('items_to_apply', {
                            initialValue: tempItems,
                            rules: [
                                {
                                    required: true,
                                    message: 'Selecciona al menos un producto',
                                },
                            ],
                            getValueFromEvent: this.onItemsToApplyChange,
                        })(
                            <Select
                                mode="multiple"
                                labelInValue
                                // value={this.props.items_to_apply}
                                placeholder="Busca productos"
                                notFoundContent={this.state.fetching ? <Spin size="small" /> : null}
                                filterOption={false}
                                onSearch={this.fetchItems}
                                disabled={this.props.isLoading}
                                // onChange={this.onItemsToApplyChange}
                                style={{ width: '100%' }}
                            >
                                {this.state.autoCompleteResult.filter((g) => g.value).filter(this.filterAlreadySelected('items_to_apply')).map((d) => (
                                    <Option key={d.value}>{d.text}</Option>
                                ))}
                            </Select>,
                        )}
                    </div>
                </Form.Item>
            )
        }
        if (this.props.apply_to.value && this.props.apply_to.value === 'specific_categories') {
            return (
                <Form.Item label="Elige categorias a aplicar">
                    {getFieldDecorator('items_to_apply', {
                        initialValue: tempItems,
                        rules: [
                            {
                                required: true,
                                message: 'Selecciona al menos una categoria',
                            },
                        ],
                        getValueFromEvent: this.onItemsToApplyChange,
                    })(
                        <Select
                            mode="multiple"
                            labelInValue
                            // value={value}
                            placeholder="Busca categorias"
                            notFoundContent={this.state.fetching ? <Spin size="small" /> : null}
                            filterOption={false}
                            onSearch={this.fetchItems}
                            disabled={this.props.isLoading}
                            // onChange={this.onItemsToApplyChange}
                            style={{ width: '100%' }}
                        >
                            {this.state.autoCompleteResult.filter((g) => g.value).filter(this.filterAlreadySelected('items_to_apply')).map((d) => (
                                <Option key={d.value}>{d.text}</Option>
                            ))}
                        </Select>,
                    )}
                </Form.Item>
            )
        }
        if (this.props.apply_to.value && this.props.apply_to.value === 'specific_brands') {
            return (
                <Form.Item label="Elige marcas a aplicar">
                    {getFieldDecorator('items_to_apply', {
                        initialValue: tempItems,
                        rules: [
                            {
                                required: true,
                                message: 'Selecciona al menos una marca',
                            },
                        ],
                        getValueFromEvent: this.onItemsToApplyChange,
                    })(
                        <Select
                            mode="multiple"
                            labelInValue
                            // value={value}
                            placeholder="Busca marcas"
                            notFoundContent={this.state.fetching ? <Spin size="small" /> : null}
                            filterOption={false}
                            onSearch={this.fetchItems}
                            disabled={this.props.isLoading}
                            // onChange={this.onItemsToApplyChange}
                            style={{ width: '100%' }}
                        >
                            {this.state.autoCompleteResult.filter((g) => g.value).filter(this.filterAlreadySelected('items_to_apply')).map((d) => (
                                <Option key={d.value}>{d.text}</Option>
                            ))}
                        </Select>,
                    )}
                </Form.Item>
            )
        }
        if (this.props.apply_to.value && this.props.apply_to.value === 'specific_product_types') {
            return (
                <Form.Item label="Eliga un tipo de producto">
                    {getFieldDecorator('items_to_apply', {
                        initialValue: tempItems,
                        rules: [
                            {
                                required: true,
                                message: 'Seleccione al menos un tipo de producto',
                            },
                        ],
                        getValueFromEvent: this.onItemsToApplyChange,
                    })(
                        <Select
                            mode="multiple"
                            labelInValue
                            // value={value}
                            placeholder="Busca tipo de productos"
                            notFoundContent={this.state.fetching ? <Spin size="small" /> : null}
                            filterOption={false}
                            onSearch={this.fetchItems}
                            disabled={this.props.isLoading}
                            // onChange={this.onItemsToApplyChange}
                            style={{ width: '100%' }}
                        >
                            {this.state.autoCompleteResult.filter((g) => g.value).filter(this.filterAlreadySelected('items_to_apply')).map((d) => (
                                <Option key={d.value}>{d.text}</Option>
                            ))}
                        </Select>,
                    )}
                </Form.Item>
            )
        }
    }

    render() {
        // eslint-disable-next-line no-unused-vars
        // const { getFieldDecorator } = this.props.form

        return (
            <Row>
                <Col xs={24} sm={24} md={24} lg={24} xl={{ span: 12, offset: 6 }}>
                    <Form onSubmit={this.handleSubmit}>
                        {this.props.type.value === 'quantity_based' ? (
                            <>
                                {this.renderApplyTo()}
                                {this.props.apply_to.value && this.props.apply_to.value !== 'all_products' && (this.renderItemsToApply())}
                            </>
                        ) : (null)}
                        {this.renderItemBasedType()}
                        <Form.Item style={{ textAlign: 'center' }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={this.props.isLoading}
                                loading={this.props.isLoading}
                            >
                                Siguiente
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        )
    }
}

const WrappedDiscountsConditionForm = Form.create({
    name: 'DiscountsConditionForm',
    onFieldsChange(props, changedFields) {
        props.onFieldChange(changedFields)
    },
    mapPropsToFields(props) {
        return {
            apply_to: Form.createFormField({
                ...props.apply_to,
            }),
            apply_when_buy: Form.createFormField({
                ...props.apply_when_buy,
            }),
            items_to_apply: Form.createFormField({
                ...props.items_to_apply,
            }),
            buy_type: Form.createFormField({
                ...props.buy_type,
            }),
            item_based_each: Form.createFormField({
                ...props.item_based_each,
            }),
            quantity_from: Form.createFormField({
                ...props.quantity_from,
            }),
            quantity_rule: Form.createFormField({
                ...props.quantity_rule,
            }),
            item_based_items_to_apply: Form.createFormField({
                ...props.item_based_items_to_apply,
            }),
            items_to_apply_count_option: Form.createFormField({
                ...props.items_to_apply_count_option,
            }),
            items_to_apply_count: Form.createFormField({
                ...props.items_to_apply_count,
            }),
            items_to_buy: Form.createFormField({
                ...props.items_to_buy,
            }),
            quantity_to: Form.createFormField({
                ...props.quantity_to,
            }),
            // priority: Form.createFormField({
            // 	...props.priority
            // }),
            // type: Form.createFormField({
            // 	...props.type
            // })
        }
    },
})(DiscountsConditionForm)

export default WrappedDiscountsConditionForm
